import * as React from 'react';
import { useEffect, useState } from 'react';

export interface IconProps {
  url: string | false;
  className?: string;
}

export const Icon = (props: IconProps) => {
  const [src, setSrc] = useState('');
  const isPrintMode = typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('print') === 'true';

  useEffect(() => {
    setSrc(props.url !== false ? props.url : '');
  }, [props.url]);

  const srcProps = isPrintMode
    ? (props.url !== false ? { src: props.url } : {})
    : (src ? { src } : {});

  return <img className={props.className} {...srcProps} />;
};

export const IconDisplay = ({visible, url, classNames}) => url && visible ? <Icon className={classNames} url={url} /> : null;
